unit Essentials.Web.RequiredFields.EditValueForm;

interface

uses
  System.SysUtils, System.Variants, System.Classes, Vcl.Graphics,
  Vcl.Controls, Vcl.Forms, Vcl.Dialogs, Essentials.Web.BaseEditForm, Data.DB,
  WEBLib.DB, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.ExtCtrls, WEBLib.DBCtrls, Essentials.Web.Shared;

type
  TRequiredFieldsEditValue = class(TEssentialsBaseEditForm)
    EntitySelector: TDBLookupComboBox;
    FieldSelector: TDBLookupComboBox;
    procedure WebFormCreate(Sender: TObject);
    procedure EntitySelectorChange(Sender: TObject);
    procedure FieldSelectorChange(Sender: TObject);
  private
    { Private declarations }
  protected
    function AllRequiredFieldsAreSet: Boolean; override;
  public
    { Public declarations }
    procedure LoadEntityList;
    procedure SetEditMode(const Value: TEditMode); override;
  protected procedure LoadDFMValues; override; end;

var
  RequiredFieldsEditValue: TRequiredFieldsEditValue;

implementation

uses Essentials.Web.Manager, Essentials.Shared,
Generics.Collections, SMX.Web.Utils;

{$R *.dfm}

{ TRequiredFieldsEditValue }

function TRequiredFieldsEditValue.AllRequiredFieldsAreSet: Boolean;
begin
  Result := (FieldSelector.ItemIndex > -1) and (EntitySelector.ItemIndex > -1);
end;

procedure TRequiredFieldsEditValue.EntitySelectorChange(Sender: TObject);
var
  selectedValue: string;
  lFields: TList<string>;
  fld: string;
begin
  selectedValue := EntitySelector.Value;
  FieldSelector.LookupValues.Clear;

//  lFields := EssentialsManager.LookUpManager.RegisteredFields[selectedValue];
  lFields := EssentialsManager.RequiredFieldsManager.RegisteredFields[selectedValue];

  if Assigned(lFields) then
  begin
    for fld in lFields do
    begin
      FieldSelector.LookupValues.AddPair(fld, TUtils.SplitOnCaps(fld));
    end;

    if FieldSelector.LookupValues.Count > 0 then
      FieldSelector.ItemIndex := 0;

  end;
  UpdateState;
end;

procedure TRequiredFieldsEditValue.FieldSelectorChange(Sender: TObject);
begin
  inherited;
  UpdateState;
end;

procedure TRequiredFieldsEditValue.LoadEntityList;
var
  lDef: TdtoLookupDef;
  lName, lCustom: string;
  lAssigned: Boolean;
begin
  for lDef in EssentialsManager.RequiredFieldsManager.RegisteredEntities do
  begin
    lName := lDef.EntityClassName;
    lAssigned := Assigned(EssentialsManager.RequiredFieldsManager);
    if lAssigned then
    begin
      lCustom := EssentialsManager.CustomNamesManager.EntityCustomName(lName);
      EntitySelector.LookupValues.AddPair(lName, lCustom);
    end;
  end;

  if EntitySelector.LookupValues.Count > 0 then
  begin
    EntitySelector.ItemIndex := 0;
    EntitySelectorChange(EntitySelector);
  end;
end;

procedure TRequiredFieldsEditValue.SetEditMode(const Value: TEditMode);
begin
  inherited;
  if FEditMode <> None then
  begin
    EntitySelector.Enabled := FEditMode = Add;
    FieldSelector.Enabled := FEditMode = Add;
    EntitySelector.SetFocus;
  end;
end;

procedure TRequiredFieldsEditValue.WebFormCreate(Sender: TObject);
begin
  inherited;
  EntitySelector.Enabled := False;
  FieldSelector.Enabled := False;
end;

procedure TRequiredFieldsEditValue.LoadDFMValues;
begin
  inherited LoadDFMValues;

  EntitySelector := TDBLookupComboBox.Create('essentials.requiredfields.entity.selector');
  FieldSelector := TDBLookupComboBox.Create('essentials.requiredfields.field.selector');

  TitleBarLabel.BeforeLoadDFMValues;
  EntitySelector.BeforeLoadDFMValues;
  FieldSelector.BeforeLoadDFMValues;
  try
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    TitleBarLabel.Width := 100;
    TitleBarLabel.Caption := 'Add Required Field';
    EntitySelector.SetParentComponent(Self);
    EntitySelector.Name := 'EntitySelector';
    EntitySelector.Left := 65;
    EntitySelector.Top := 113;
    EntitySelector.Width := 145;
    EntitySelector.Height := 22;
    EntitySelector.ElementClassName := 'custom-select';
    EntitySelector.ElementFont := efCSS;
    EntitySelector.HeightPercent := 100.000000000000000000;
    EntitySelector.WidthPercent := 100.000000000000000000;
    SetEvent(EntitySelector, Self, 'OnChange', 'EntitySelectorChange');
    EntitySelector.DataField := 'EntityClassName';
    EntitySelector.DataSource := DataSource;
    FieldSelector.SetParentComponent(Self);
    FieldSelector.Name := 'FieldSelector';
    FieldSelector.Left := 216;
    FieldSelector.Top := 113;
    FieldSelector.Width := 145;
    FieldSelector.Height := 22;
    FieldSelector.ElementClassName := 'custom-select';
    FieldSelector.ElementFont := efCSS;
    FieldSelector.HeightPercent := 100.000000000000000000;
    FieldSelector.WidthPercent := 100.000000000000000000;
    SetEvent(FieldSelector, Self, 'OnChange', 'FieldSelectorChange');
    FieldSelector.DataField := 'FieldName';
    FieldSelector.DataSource := DataSource;
  finally
    TitleBarLabel.AfterLoadDFMValues;
    EntitySelector.AfterLoadDFMValues;
    FieldSelector.AfterLoadDFMValues;
  end;
end;

end.
